/** Featured chips shown on onboarding Industry step (plus trailing "Other"). */
export const FEATURED_INDUSTRIES = [
  "Software Publishers",
  "Computer Systems Design Services",
  "Architectural Services",
  "Automobile Manufacturing",
  "Offices of Physicians",
  "Sign Manufacturing",
];

/**
 * Fallback options for the Other multi-select when /extent/industry/ is unavailable.
 * Excludes featured chips so the dropdown only lists remaining industries.
 */
export const FALLBACK_REMAINING_INDUSTRIES = [
  "Specialized Freight Trucking, Local",
  "Air-Conditioning and Warm Air Heating Equipment Manufacturing",
  "Commercial Banking",
  "Management Consulting Services",
  "Engineering Services",
  "Custom Computer Programming Services",
  "Data Processing, Hosting, and Related Services",
  "Full-Service Restaurants",
  "Hotels (except Casino Hotels) and Motels",
].filter((label) => !FEATURED_INDUSTRIES.includes(label));

/** @deprecated Use FEATURED_INDUSTRIES */
export const COMMON_INDUSTRIES = FEATURED_INDUSTRIES;

export const OTHER_INDUSTRY = "Other";

/** Fallback location choices when /extent/locations/ is unavailable (public onboarding). */
export const FALLBACK_LOCATIONS = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
  "District of Columbia",
];

export const COUNTRY_CODES = [
  { code: "+1", label: "US +1" },
  { code: "+44", label: "UK +44" },
  { code: "+91", label: "IN +91" },
  { code: "+61", label: "AU +61" },
  { code: "+49", label: "DE +49" },
  { code: "+33", label: "FR +33" },
  { code: "+81", label: "JP +81" },
  { code: "+86", label: "CN +86" },
  { code: "+55", label: "BR +55" },
  { code: "+52", label: "MX +52" },
];

export const ONBOARDING_STEPS = [
  { id: "industry", key: 0 },
  { id: "location", key: 1 },
  { id: "revenue", key: 2 },
  { id: "searchName", key: 3 },
];
